module.exports = __webpack_public_path__ + "img/android-chrome-256x256.6e30180b.png";